import "../assets/StopList.css";

export default function StopList({ stops, onStopClick, selectedStopId }) {
  // If stops is undefined or null, show loading
  if (!stops) {
    return (
      <div className="stop-list">
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <span>Loading stops...</span>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M4 16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z"/>
          </svg>
        </div>
      </div>
    );
  }

  // Only show "No stops available" if we have a non-empty array and it's empty
  if (Array.isArray(stops) && stops.length === 0) {
    return <div className="stop-list">No stops available.</div>;
  }

  return (
    <div className="stop-list">
      <ul
        className="list-unstyled p-3"
        style={{
          height: "456px",
          overflowY: "scroll",
          borderRadius: "8px",
          border: "2px solid #B4BBC5",
        }}
      >
        {stops.map((stop) => (
          <li
            key={stop.id}
            className={
              selectedStopId === stop.id
                ? "selected pb-lg-4 pb-3 body-copy__small"
                : "pb-lg-4 pb-3 body-copy__small"
            }
          >
            <button
              type="button"
              className="link-button"
              onClick={() => {
                console.log('StopList button clicked:', stop);
                onStopClick(stop);
              }}
              aria-label={`Select stop ${stop.title} with ID ${stop.stopId}`}
            >
              {stop.title + " - " + "#" + stop.stopId}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
